import { Flex, Skeleton } from "antd";

export default function QuizContentLoading() {
  return (
    <section>
      <div className="flex justify-between items-center mb-6">
        <Skeleton.Input active className="!h-8 !w-48" />
      </div>

      {/* ================= HEADER SKELETON ================= */}
      <div className="p-5 bg-white border border-theme-zinc-200 rounded-xl mb-4">
        <Flex justify="space-between" className="mb-2">
          <div className="flex-1">
            <Skeleton.Input active className="!h-5 !w-24 mb-2" />
            <Skeleton
              active
              paragraph={{ rows: 1, width: "80%" }}
              title={false}
            />
          </div>
        </Flex>
        <div className="relative top-1">
          <Flex justify="space-between" className="relative top-1 mb-3">
            <Skeleton.Button active className="!h-5 !w-24" />
            <Skeleton.Button active className="!h-5 !w-32" />
          </Flex>
          <Skeleton.Input active className="!h-3 !w-full !rounded-full" />
        </div>
      </div>

      {/* ================= QUESTION SKELETON ================= */}
      <div className="p-5 bg-white border border-theme-zinc-200 rounded-xl">
        <Skeleton.Input active className="!h-6 !w-3/4 mb-4" />

        <div className="space-y-3">
          {[1, 2, 3, 4].map((item) => (
            <div
              key={item}
              className="p-4 border border-theme-zinc-200 rounded-lg"
            >
              <Skeleton
                active
                paragraph={{ rows: 1, width: "90%" }}
                title={false}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
